var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrmIntegrationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.664,
    height: 32.664,
    viewBox: "0 0 32.664 32.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-20.464 -20.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3368",
    "data-name": "Path 3368",
    d: "M25.019,13.938A11.083,11.083,0,1,0,36.1,25.019,11.086,11.086,0,0,0,25.019,13.938Zm0,4.666A6.416,6.416,0,1,1,18.6,25.019,6.421,6.421,0,0,1,25.019,18.6Z",
    transform: "translate(11.778 11.789)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3369",
    "data-name": "Path 3369",
    d: "M21.416,19.831V14.583a2.333,2.333,0,1,0-4.666,0v5.251a2.333,2.333,0,1,0,4.666,0Z",
    transform: "translate(17.713 8.225)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3370",
    "data-name": "Path 3370",
    d: "M22.721,21.264l3.711-3.714a2.332,2.332,0,0,0-3.3-3.3L19.42,17.963a2.334,2.334,0,0,0,3.3,3.3Z",
    transform: "translate(21.912 11.008)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3371",
    "data-name": "Path 3371",
    d: "M21.893,21.416h5.251a2.333,2.333,0,1,0,0-4.666H21.893a2.333,2.333,0,0,0,0,4.666Z",
    transform: "translate(23.651 17.725)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3372",
    "data-name": "Path 3372",
    d: "M19.42,22.721l3.714,3.711a2.332,2.332,0,0,0,3.3-3.3L22.721,19.42a2.334,2.334,0,0,0-3.3,3.3Z",
    transform: "translate(21.912 21.923)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3373",
    "data-name": "Path 3373",
    d: "M16.75,21.9v5.251a2.333,2.333,0,0,0,4.666,0V21.9a2.333,2.333,0,0,0-4.666,0Z",
    transform: "translate(17.713 23.66)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3374",
    "data-name": "Path 3374",
    d: "M17.963,19.42l-3.711,3.714a2.332,2.332,0,0,0,3.3,3.3l3.714-3.711a2.334,2.334,0,1,0-3.3-3.3Z",
    transform: "translate(10.997 21.923)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3375",
    "data-name": "Path 3375",
    d: "M19.831,16.75H14.583a2.333,2.333,0,1,0,0,4.666h5.248a2.333,2.333,0,1,0,0-4.666Z",
    transform: "translate(8.214 17.725)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3376",
    "data-name": "Path 3376",
    d: "M21.264,17.963l-3.714-3.711a2.332,2.332,0,0,0-3.3,3.3l3.711,3.714a2.334,2.334,0,0,0,3.3-3.3Z",
    transform: "translate(10.997 11.008)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmIntegrationIcon);
export default __webpack_public_path__ + "static/media/crm_integration_icon.762941a22dcfca1fd367c5e2246c2462.svg";
export { ForwardRef as ReactComponent };